export const DB = {
  users: process.env.REACT_APP_USERS_CONTAINER_ID || "Users",
  companies: process.env.REACT_APP_COMPANIES_CONTAINER_ID || "Companies",
};
